import { Navigate, Route } from 'react-router-dom';
import { hasPermission, subjectForUser } from '@/app/config/navPermissions';
import { useAuth } from '@/platform/authentication/hooks/useAuth';
import {
  DesignCanvasShellDemo,
  DesignDndDemo,
  DesignIndex,
  DesignInspectorPanelDemo,
  DesignQuickConfigPopoverDemo,
  DesignSourcePillDemo,
  DesignStatusPillDemo,
  DesignStepperDemo,
  DesignUndoRedoDemo,
  DesignVersionRibbonDemo,
} from '@/platform/design-system/routes/lazyPages';
import {
  DesignDryRunModeDemo,
  DesignRunwayShapesDemo,
} from '@/workflows/automation/public/routes/lazyPages';

function DesignRoleGate({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  if (!hasPermission(subjectForUser(user), 'design:read')) {
    return <Navigate to="/workbench" replace />;
  }
  return <>{children}</>;
}

export const DESIGN_ROUTE_ELEMENTS = (
  <>
    <Route
      path="design"
      element={<DesignRoleGate><DesignIndex /></DesignRoleGate>}
    />
    <Route
      path="design/stepper"
      element={<DesignRoleGate><DesignStepperDemo /></DesignRoleGate>}
    />
    <Route
      path="design/inspector-panel"
      element={<DesignRoleGate><DesignInspectorPanelDemo /></DesignRoleGate>}
    />
    <Route
      path="design/undo-redo"
      element={<DesignRoleGate><DesignUndoRedoDemo /></DesignRoleGate>}
    />
    <Route
      path="design/version-ribbon"
      element={<DesignRoleGate><DesignVersionRibbonDemo /></DesignRoleGate>}
    />
    <Route
      path="design/quick-config-popover"
      element={<DesignRoleGate><DesignQuickConfigPopoverDemo /></DesignRoleGate>}
    />
    <Route
      path="design/dry-run-mode"
      element={<DesignRoleGate><DesignDryRunModeDemo /></DesignRoleGate>}
    />
    <Route
      path="design/status-pill"
      element={<DesignRoleGate><DesignStatusPillDemo /></DesignRoleGate>}
    />
    <Route
      path="design/source-pill"
      element={<DesignRoleGate><DesignSourcePillDemo /></DesignRoleGate>}
    />
    <Route
      path="design/dnd"
      element={<DesignRoleGate><DesignDndDemo /></DesignRoleGate>}
    />
    <Route
      path="design/canvas-shell"
      element={<DesignRoleGate><DesignCanvasShellDemo /></DesignRoleGate>}
    />
    <Route
      path="design/runway-shapes"
      element={<DesignRoleGate><DesignRunwayShapesDemo /></DesignRoleGate>}
    />
  </>
);
